module.exports = __webpack_public_path__ + "img/img10.2d666968.png";